import React, { useContext } from 'react'
import { useLocation, Link } from 'react-router-dom'

import './header.scss'

import { UIContext } from '../../contexts/ui'
import { DBContext } from '../../contexts/databases'
import { useAuth } from '../../contexts/auth'

function Header(props) {
	const { Theme, setTheme } = useContext(UIContext)
	const { isDbRefreshed } = useContext(DBContext)
	const { isAuthenticated, user, logout } = useAuth()
	const onThemeChange = (event) => {
		setTheme(event.target.value)
	}
	let location = 'Simulator'
	switch (useLocation().pathname) {
		case '/expscaler':
			location = 'Exp Scaler'
			break
		case '/refine':
			location = 'Refine'
			break
		case '/news':
			location = 'Patch Notes'
			break
		case '/contact':
			location = 'Contact'
			break
		case '/about':
			location = 'About'
			break
		case '/index':
		default:
			location = 'Stats and Battle Simulator'
			break
	}
	// location = location.toUpperCase()
	return (
		<header className='Header'>
			<h1>
				{location}
				<span className={`db-status ${isDbRefreshed ? 'db-ready' : 'db-loading'}`}>
					{isDbRefreshed ? '● DB ready' : '○ Loading DB…'}
				</span>
			</h1>
			<nav>
				<ul>
					<li>
						Choose theme :
						<select
							name='ThemeSelector'
							id='ThemeSelector'
							onChange={onThemeChange}
							value={Theme}
						>
							<option value={0}>Basic</option>
							<option value={1}>Scrambling kid</option>
							<option value={2}>Metal</option>
						</select>
					</li>
					<li className='auth-nav'>
						{isAuthenticated ? (
							<>
								<Link to='/account' className='auth-email'>{user.username}</Link>
								<button className='auth-logout-btn' onClick={logout}>Logout</button>
							</>
						) : (
							<Link to='/login' className='auth-login-btn'>Log in</Link>
						)}
					</li>
				</ul>
			</nav>
		</header>
	)
}

export default Header
